import { useMemo } from "react";
import { createDownloadPng } from "../exportHandlers.js";
import { createDownloadPdf } from "../exportPdf.js";

export function usePosterExport({
  posterRef,
  selectedRecipe,
  selectedTemplate,
  user,
  preloadedImageUrl,
  logoDataUrl,
  setDownloading,
  setError,
}) {
  return useMemo(
    () => ({
      handleDownloadPng: createDownloadPng(
        selectedRecipe,
        selectedTemplate,
        user,
        preloadedImageUrl,
        logoDataUrl,
        setDownloading,
        setError,
      ),
      handleDownloadPdf: createDownloadPdf(
        selectedRecipe,
        selectedTemplate,
        user,
        preloadedImageUrl,
        logoDataUrl,
        setDownloading,
        setError,
      ),
    }),
    [
      selectedRecipe,
      selectedTemplate,
      user,
      preloadedImageUrl,
      logoDataUrl,
      setDownloading,
      setError,
    ],
  );
}
